/**
 *
 * Bind the Javascript helper functions to the Price display and ROI gui
 *
 */
var priceCalc;
var rentaCalc;

/**
 * Price Calculator Class. 
 */
function PriceCalculator() {
	/**
	 * input
	 */
	this.users = 1; // input: number of users
	this.billinginterval = 12; // input: billing interval in months
	this.featureset = 'rp'; // input: featureset id string (rp/to/rpto)
	this.integration = 'none'; // input: integration id string (none/api/dynamics-crm)
	this.billingCountry; // input: billing country (TAX)
	this.applyVat; // input: apply VAT (TAX). The decision if a valid VAT ID has been entered is up to the caller
	// this.selectedservices sind nur die wichrklich angeklickten/selektierten services wie sie aus dem frontend kommen
	// können aber müssen nicht initialisiert sein (es kann auch nix drin stehn weil initial kein service selektiert ist)
	this.selectedservices = ptShop.selectedshopservices; // input: services in an array ['starterpaket','setupworkshop',...]

	/**
	 * output
	 */
	this.usersrangepoint; // output: discount range
	this.perUser; //output: number. price per user
	this.licenseamount; // output: number: payment on each license.
	this.servicesamount; // output: number: payment on services.
	this.invoiceamount; // output: number: payment on each invoice.
	this.vatrate; // output: VAT rate (if applicable, otherwise null)
	this.vatamount; // output: VAT amount added to price (if applicable, otherwise null)
	this.invoiceamountinclvat; // output: number: payment including VAT.
}

/**
 * Calculate the updated price based on the input properties.
 *  
 * NOTE: you must change PtShop->getPrice(), too. 
 */
PriceCalculator.prototype.update = function () {
	// Parameter Checks...
	if (typeof this.billinginterval === "string")
		this.billinginterval = parseInt(this.billinginterval);
	
	if ((typeof this.users === "undefined")||(parseInt(this.users) === 0)||(this.users==''))
		throw new Error("Amount of field reps is not set");
	if (typeof this.billinginterval === "undefined")
		throw new Error("Billing interval is not set");
	if (!ptShop.prices_discount_threshold.m.includes(this.billinginterval))
	  throw new Error("Billing interval threshold unknown: "+this.billinginterval);
	if (typeof this.featureset === "undefined")
		throw new Error("Featureset is not set");
	if (typeof this.integration === "undefined")
		throw new Error("Integration is not set");
	if (typeof this.selectedservices !== "object")
		throw new Error("selectedservices should be of type object but it is "+typeof this.selectedservices);
	
	var lookupintegration = null;
	if (this.integration=='dynamics-crm' || this.integration=='salesforce' || this.integration=='veeva')
		lookupintegration = 'crm';
	else if (this.integration=='api' || this.integration=='none')
		lookupintegration = 'none';
	else 
		throw new Error("Integration "+this.integration+ " unknown");
	
	// Price calculation
	// 
	// find the threshold for users discount
	this.usersrangepoint = null;
	for (var usersThreshold of ptShop.prices_discount_threshold.u) {
		if (this.users >= usersThreshold){
			this.usersrangepoint = usersThreshold;
			// Note: do not "break;" here, an even better discount may wait higher up in the thresholds
		}
	}
	
	if (this.usersrangepoint === null)
		throw new Error("Could not find usersrangepoint (discount threshold) for "+this.users+" users");
	
	// sum up the selected services
	this.servicesamount = 0;
	
	if(this.selectedservices.length) {
		for (var service of this.selectedservices) {
			this.servicesamount += ptShop.prices.services[service]-ptShop.prices.servicesonlinesavings[service];
		};
	}
	
	// lookup based on users and billinginterval, which was already verified above during Parameter Checks
	const priceLookupKey = 'u'+this.usersrangepoint + "m"+this.billinginterval;
	
	// lookup the price
	this.perUser = ptShop.prices.featureset[this.featureset][priceLookupKey];
	  
	// additional cost depending on integration
	var integrationAddOnPrice = ptShop.prices.integration[lookupintegration];
	
	// apply additional cost for integrationAddOnPrice
	this.perUser += integrationAddOnPrice;
	
	this.licenseamount = this.users * this.perUser * this.billinginterval;
	// round to two Kommastellen
	this.licenseamount = (Math.round(this.licenseamount * 100) / 100);
	
	this.invoiceamount = this.servicesamount + this.licenseamount;

	// TAX?
	if (this.applyVat) {
		if (this.billingCountry === undefined) {
			throw new Error("VAT should be applied, but billing country is missing.");
		}
		this.vatrate = ptShop.vatRatePerCountry[this.billingCountry];
		this.vatamount = this.invoiceamount * this.vatrate;
		this.vatamount = Math.round(this.vatamount * 100) / 100; // round to two Kommastellen
		// both summands are rounded to two Nachkommastellen -> BUT in the addition, Javascript rounds again. Hence result needs to be rounded, too.
		// ex: 479.7 + 100.74 = 580.4399999999999, see FS#7942
		this.invoiceamountinclvat = Math.round((this.invoiceamount + this.vatamount) * 100) / 100; 
		
	} else {
		// VAT applicable?
		this.vatrate = 0;
		this.vatamount = 0;
		this.invoiceamountinclvat = this.invoiceamount;
	}
}

/**
 * Get the Service Price and Discount
 */
PriceCalculator.prototype.getServicePrices = function (service) {
	
	return [ptShop.prices.services[service]-ptShop.prices.servicesonlinesavings[service], ptShop.prices.services[service]];
}

/**
 * Given the months in the function parameter, return the discount applicable based on the current featureset and users
 * used by the pricing-gui.js
 * months: integer. 3, 12 or 36, one of ptShop.prices_discount_threshold.m
 */
PriceCalculator.prototype.getBillingintervalDiscount = function (months) {
	// current users range point as lookupkey-prefix
	const priceLookupKeyPrefix = 'u' + this.usersrangepoint;
	
	// most expensive
	const undiscountedKeySuffix = 'm' + ptShop.prices_discount_threshold.m[0];
	const discountedKeySuffix = 'm' + months;
	
	const undiscountedPrice = ptShop.prices.featureset[this.featureset][priceLookupKeyPrefix + undiscountedKeySuffix];
	const discountedPrice = ptShop.prices.featureset[this.featureset][priceLookupKeyPrefix + discountedKeySuffix];
	
	return discountedPrice - undiscountedPrice; // we return a negative number, the discount as in "-10USD !"
}

/**
 * Given the users range in the function parameter, return the discount applicable based on the current featureset and billinginterval
 * used by the pricing-gui.js
 * users: integer. 1,10 one of ptShop.prices_discount_threshold.u
 */
PriceCalculator.prototype.getUsersDiscount = function (users) {
	// most expensive
	const undiscountedKeyPrefix = 'u' + ptShop.prices_discount_threshold.u[0];
	const discountedKeyPrefix = 'u' + users;
	
	// current billing interval in months lookupkey-suffix
	const monthsLookupKeySuffix = "m"+this.billinginterval;
	
	const undiscountedPrice = ptShop.prices.featureset[this.featureset][undiscountedKeyPrefix + monthsLookupKeySuffix];
	const discountedPrice = ptShop.prices.featureset[this.featureset][discountedKeyPrefix + monthsLookupKeySuffix];
	
	return discountedPrice - undiscountedPrice; // we return a negative number, the discount as in "-10USD !"
}


/**
 * Rentability calculator.
 * Triggered both by changes to users and integration as by changes to the rentability model.
 */
function RentabilityCalculator(priceCalc) {
	this.debug=false;
	this.priceCalc = priceCalc; // used to know the variables for price-calculation that are NOT "the user". Updated by setUserPrice
	// config, updated by initShow()
	this.distanceUnit = 'km'; //km or m
	this.distanceUnitName = 'Kilometer'; // localized
	this.countriesUsingMiles = ['GB', 'US', 'AS', 'BS', 'BZ', 'VG', 'KY', 'DM', 'FK', 'GD','GU', 'MM', 'MP', 'WS', 'LC', 'VC', 'SH', 'KN', 'TC', 'VI']; // see http://en.wikipedia.org/wiki/Mile
	this.carCostPerDistanceStandards = {
		'US': {r:0.565,unit:'mi',currency:'USD', country:'US'},
		'MX': {r:0.25,unit:'km',currency:'USD', country:'MX'},	
		'DE': {r:0.3,unit:'km',currency:'EUR', country:'DE'},
		'AT': {r:0.42,unit:'km',currency:'EUR', country:'AT'},
		'BR': {r:0.95,unit:'km',currency:'BRL', country:'BR'},
		'ES': {r:0.35,unit:'km',currency:'EUR', country:'ES'},
		'IT': {r:0.6,unit:'km',currency:'EUR', country:'IT'}
	};
	this.distanceConversion = {
		'mi-km': 1.609344,
		'km-mi': 0.621371192
	};
	this.currencyConversion = {
		'EUR-USD': 0.739,
		'USD-EUR': 1.353179973
	};
	
	//used to determine wether we calculate 1 or 12 months
	this.timeSpan = 12;
	
	// input zeile 1
	this.distanceTotal;	//in miles or km
	this.distance;	//in miles or km
	this.planningTimePerWeek = 4;	// in hours
	this.callsPerDay = 8;
	this.salaryPerMonth = 3000;
	
	// input zeile 2
	this.carCostPerDistance = 0.57;	// 0,57 USD/Mile or 0,42€/km
	this.workDaysPerMonth = 20; 
	this.workHoursPerDay = 8;
	this.salaryMultiplierEmployersContributions  = 1.5;
	
	// input zeile 3
	this.users = 1;	// number of users
	
	//fixe Prozentwerte
	this.estimatedSavedDistance = -0.15;	// % 
	this.estimatedSavedPlanningTime = -0.75;	// %
	
	//dynamische Prozentwerte
	this.estimatedAdditionalCalls = 0.15;	// %
	
	//magic number to determine more calls because of better routes
	this.estimatedAdditionalCallsViaOptimizedRoutes = 0.175;
	
	//box1
	this.resultDistance;	// one rep
	this.resultDistanceDifference;
	
	//box2
	this.planningTimeDisplay;
	this.savedPlanningTimeDisplay;
	this.resultPlanningTime;
	this.resultCallsPerHour;
	this.resultMoreCallsTotalByPlanning;
	
	//box3
 	this.callsTotal;
 	this.resultCallsTotal;
	this.resultMoreCallsTotalByOptimizedRoutes;
	this.resultMoreCallsTotal;
	this.calculatedCallsPercentage;
	
	//box4
	this.costOfFieldForceWithoutPt;
	this.savedCarCostFieldForce;
	this.licenseCosts; // price per user per month
	this.savingsTotal;
	this.costOfFieldForceWithPt;
	
	
	//resultbox
	this.costPerVisitWithPt;
	this.costPerVisitWithoutPt;
	this.additionalCosts;
	
	this.generatedURLVars;
	
	// sanity checks
	if (!ptShop.currency)
		throw new Exception("ROI-Calculator: Currency not initialized");
	
	// initalize default values
	var myCostPerDistanceObject = null;
	var cntry = ptShop.country;
	if ((typeof cntry === "undefined")||(cntry===null)) {
		if (pLang_Language=='de') {
			this.distanceUnit = 'km';
			myCostPerDistanceObject = this.carCostPerDistanceStandards.DE;
		} else if (pLang_Language=='en') {
			this.distanceUnit = 'mi';
			myCostPerDistanceObject = this.carCostPerDistanceStandards.US;
		}
	} else {
		cntry = cntry.toUpperCase();
		if ($.inArray(cntry, this.countriesUsingMiles) >= 0) 
			this.distanceUnit = 'mi';
		else 
			this.distanceUnit = 'km';
			
		if (this.carCostPerDistanceStandards.hasOwnProperty(cntry))
			myCostPerDistanceObject = this.carCostPerDistanceStandards[cntry];
		else 
			// miles or kilometers? Pick DE or US
			if ('mi' == this.distanceUnit)
				myCostPerDistanceObject = this.carCostPerDistanceStandards.US;
			else
				myCostPerDistanceObject = this.carCostPerDistanceStandards.DE;
	}
	if (myCostPerDistanceObject == null)
		throw new Error("Cannot find standard car costs for country "+cntry);
	if ('mi' == this.distanceUnit) {
		if(!this.distance) this.distance = 24000; 
		this.distanceUnitName = pLang__('distanceunitmiles');
	} else if ('km' == this.distanceUnit) {
		if(!this.distance) this.distance = 40000; 
		this.distanceUnitName = pLang__('distanceunitkilometers');
	} else
		throw new Error("Distance unit "+this.distanceUnit+" not known. m or km are supported.");
	// get car cost in right distance unit and currency
	this.carCostPerDistance = myCostPerDistanceObject.r;
	if (this.distanceUnit != myCostPerDistanceObject.unit) {
		this.carCostPerDistance = this.carCostPerDistance / this.distanceConversion[myCostPerDistanceObject.unit+'-'+this.distanceUnit];
	}
	if (ptShop.currency != myCostPerDistanceObject.currency) {
		this.carCostPerDistance = this.carCostPerDistance * this.currencyConversion[myCostPerDistanceObject.currency+'-'+ptShop.currency];
	}
	this.country = cntry;
	
	if(this.initShow) this.initShow(this);
}

// pass price and usercount, update roi gui
RentabilityCalculator.prototype.setUserPrice = function(priceCalc) {
	// set the initial values from the price form
	this.priceCalc = priceCalc;
	this.users = priceCalc.users;
	if(this.showUserPrice) this.showUserPrice();
	this.pricePerUser = priceCalc.perUser;

}

RentabilityCalculator.prototype.update = function() {
	if(this.readInput) this.readInput(this);
	this.updateCalc();
	if(this.writeOutput) this.writeOutput(this);	
}

// Calculate
RentabilityCalculator.prototype.updateCalc = function() {


	// We are rounding some vars as the gui shows floats without decimals and that may lead to wrong sums

	if(this.generateURLVars) this.generatedURLVars = this.generateURLVars(this);	
	
	//box1
	this.distanceTotal = this.users * this.distance * this.timeSpan / 12;
	this.resultDistance = Math.round(this.distanceTotal * (1+this.estimatedSavedDistance));
	this.resultDistanceDifference = this.distanceTotal-this.resultDistance;
	
	//box2
	this.planningTimeDisplay = this.users * this.planningTimePerWeek * 4 * this.timeSpan;
	this.resultPlanningTime = Math.round(this.planningTimeDisplay * (1+this.estimatedSavedPlanningTime));
	this.savedPlanningTimeDisplay = this.planningTimeDisplay - this.resultPlanningTime;
	this.resultCallsPerHour = Math.round((this.callsPerDay / this.workHoursPerDay)* 10) / 10;
	this.resultMoreCallsTotalByPlanning = Math.round(this.savedPlanningTimeDisplay * this.resultCallsPerHour);
	
	//box3
	this.callsTotal = this.users * this.callsPerDay * this.workDaysPerMonth * this.timeSpan;
	this.resultMoreCallsTotalByOptimizedRoutes = Math.round((this.callsTotal * (1+this.estimatedAdditionalCallsViaOptimizedRoutes)) - this.callsTotal);
	this.resultMoreCallsTotal = this.resultMoreCallsTotalByPlanning + this.resultMoreCallsTotalByOptimizedRoutes;	
	this.resultCallsTotal = this.callsTotal + this.resultMoreCallsTotal;
	this.calculatedCallsPercentage = this.resultMoreCallsTotal*100/this.callsTotal;
	
	//box4
	this.costOfFieldForceWithoutPt = (this.users * this.salaryPerMonth * this.salaryMultiplierEmployersContributions * this.timeSpan) + (this.distanceTotal * this.carCostPerDistance);
	this.savedCarCostFieldForce = Math.round(this.resultDistanceDifference * this.carCostPerDistance);
	this.licenseCosts = Math.round(this.users * this.pricePerUser * this.timeSpan);
	this.savingsTotal = this.savedCarCostFieldForce - this.licenseCosts;
	this.costOfFieldForceWithPt = this.costOfFieldForceWithoutPt - this.savingsTotal;
	this.calculatedCostPercentage = this.savingsTotal*100/this.costOfFieldForceWithoutPt;
	
	
	//resultbox
	this.costPerVisitWithoutPt = Math.round(this.costOfFieldForceWithoutPt / this.callsTotal);
	this.costPerVisitWithPt = Math.round(this.costOfFieldForceWithPt / this.resultCallsTotal);
	
	this.additionalCosts = this.costPerVisitWithoutPt * this.resultMoreCallsTotal;
}

//encapsulate the call for the method
function priceCalculatorUpdate(e) {
	if (!priceCalc || !rentaCalc)
		return;
	
	if(rentaCalc.beforePriceCalculatorUpdate) rentaCalc.beforePriceCalculatorUpdate();
	
	try {
		priceCalc.update();
		if(rentaCalc.afterPriceCalculatorUpdate) rentaCalc.afterPriceCalculatorUpdate(e);
	} catch (e) {
		console.log("Error calculating price: "+e);
		if (e.stack !== undefined)
			console.log(e.stack);
		if(rentaCalc.errorPriceCalculatorUpdate) rentaCalc.errorPriceCalculatorUpdate(e);
	}

	// update rentability calculator
	try {
		rentaCalc.setUserPrice(priceCalc);
		rentaCalc.timeSpan = 1;
		rentaCalc.update(); 		
		if(rentaCalc.afterRentabilityCalculatorUpdate) rentaCalc.afterRentabilityCalculatorUpdate();
	} catch (e) {
		console.log("Error calculating rentability: "+e);
		if (e.stack !== undefined)
			console.log(e.stack);
	}
	// update anything else
	jQuery(document).trigger('ptPriceCalculatorUpdated');
}

// run this when the shop data is loaded
function ptShopCurrencyLoadedUpdatePricing() {
	// create and register price calculator
	if (priceCalc === undefined)
		priceCalc = new PriceCalculator();
	if ((rentaCalc === undefined) || (rentaCalc.country === undefined) || (rentaCalc.country != ptShop.country)) {
		// rentability calculator is completly new for a changed country. 
		rentaCalc = new RentabilityCalculator(priceCalc);
	}
	
	if(rentaCalc.beforeInitialRun) rentaCalc.beforeInitialRun();
		
	// make an initial run
	priceCalculatorUpdate();
}
jQuery(document).on('ptShopCurrencyLoaded',  ptShopCurrencyLoadedUpdatePricing );

